const NEEDS_QUOTING = /[",\r\n]/;

// RFC 4180: quote the value if it contains a comma, quote, CR or LF; double embedded quotes.
export const escapeCSVValue = value => {
  if (value === null || value === undefined) {
    return '';
  }
  const stringValue = String(value);
  return NEEDS_QUOTING.test(stringValue) ? "\"".concat(stringValue.replace(/"/g, '""'), "\"") : stringValue;
};
export const buildCSVContent = (headerCells, dataRows) => [headerCells, ...dataRows].map(row => row.map(escapeCSVValue).join(',')).join('\n');
export const exportCSV = (headerCells, dataRows, name) => {
  const csvContent = buildCSVContent(headerCells, dataRows);
  const blob = new Blob([csvContent], {
    type: 'text/csv;charset=utf-8;'
  });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.setAttribute('download', name);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
const getExportValue = (col, row) => {
  if (!col.renderCell) {
    return row[col.field] !== undefined ? row[col.field] : 'N/A';
  }
  // Mimic renderCell output: prefer the export-specific getter, then the display getter.
  if (col.valueGetterForExport) {
    return col.valueGetterForExport({
      row
    });
  }
  if (col.valueGetter) {
    return col.valueGetter({
      row
    });
  }
  return row[col.field] !== undefined ? row[col.field] : 'N/A';
};
export const exportCSVFromDataGrid = _ref => {
  let columns = _ref.columns,
    name = _ref.name,
    rows = _ref.rows;
  const visibleColumns = columns.filter(col => col.isExportable);
  const headerCells = visibleColumns.map(col => typeof col.headerName === 'string' ? col.headerName.replace(/\n/g, ' ') : col.headerName);
  const dataRows = rows.map(row => visibleColumns.map(col => getExportValue(col, row)));
  exportCSV(headerCells, dataRows, name);
};